/* Team K9 buy-box tests (2026-10-18). Setup, arms and kill switches: sections/tk9-bb-tests.liquid.
   Record: Pages outputs/team-k9-bb-tests-20261018/HANDOFF.md

   B arms on the product pages (A = the buy box exactly as today):
   - doggles: a "1 pair / 2 pairs" choice above Add to cart with 2 pairs chosen. The form's quantity carries it; the
     native automatic discount "Doggles - Buy 2 for $99" prices the pair in the cart. One tap on "1 pair" = 1 unit.
   - couch: Kaching's own Buy 2 bar is chosen once when the page opens (its radio, so Kaching writes its bid and the
     quantity as if tapped). One tap on Buy 1 = 1 unit.
   - 4mbh: a "Harness + custom name patch" kit option under the kit choice (Candy Rack's "Customize It?" box is hidden
     in this arm, so the patch is offered once). Ticked = a name is required before Add to cart; the patch pair is added
     as its own line right after the harness (through the slide cart's TK9CartExtraItems hook), with the same properties
     as the slide cart's patch row (name, phone, mockup and source fields). One tap on the option = no patch.
   - classic (metal-buckle-harness, product page only): the 4 metal buckle model chosen once when the picker shows.
   B arms on the landers (doggles, couch): the lander's Buy row starts on Buy 2 (window.TK9BB_QTY, read by
   assets/tk9-dtc-lander.js).
   Everywhere: the tests a visitor has seen are written to the cart (_tk9_bb_arm, _tk9_bb_v) so they land on the order,
   and the page's test is declared to Merchanting Watch. Nothing here runs for a visitor outside a test, or after a kill
   switch. */
(function () {
  var BB = window.TK9BB;
  if (!BB || BB.off || window.__tk9bbRan) return;
  window.__tk9bbRan = true;
  var C = BB.conf, test = BB.test, arm = BB.arm;

  function emit(name, data) {
    var p = { event: 'tk9_bb_' + name, tk9_bb_test: test || '', tk9_bb_arm: arm || '', tk9_bb_v: BB.v };
    for (var k in data || {}) p[k] = data[k];
    try { (window.dataLayer = window.dataLayer || []).push(p); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('tk9:bb', { detail: p })); } catch (e) {}
  }
  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2); }
  // writes only when the text changes, so the remount observer never feeds itself
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------------- the arm rides on the cart ---------------- */
  // XHR, not fetch (the layout's fetch wrapper repaints the /cart subtotal on cart writes). Other cart writes can land at
  // the same moment (the slide cart's add-on lines and its own attributes), so the cart is read back after the add has
  // settled and the attribute rewritten only when it is missing: never trusted from our own last write.
  var attrTimer = null, attrTries = 0;
  function xhr(method, url, body, done) {
    try {
      var x = new XMLHttpRequest();
      x.open(method, url);
      x.setRequestHeader('Accept', 'application/json');
      if (body) x.setRequestHeader('Content-Type', 'application/json');
      x.onloadend = function () { var j = null; try { j = JSON.parse(x.responseText); } catch (e) {} done(x.status >= 200 && x.status < 300 ? j : null); };
      x.send(body ? JSON.stringify(body) : null);
    } catch (e) { done(null); }
  }
  function ensureAttr(delay) {
    clearTimeout(attrTimer);
    attrTimer = setTimeout(function () {
      var v = BB.attr(); if (!v) return;
      xhr('GET', '/cart.js', null, function (c) {
        if (!c || !c.item_count) return;
        if ((c.attributes || {})._tk9_bb_arm === v) { attrTries = 0; return; }
        if (++attrTries > 4) return;
        xhr('POST', '/cart/update.js', { attributes: { _tk9_bb_arm: v, _tk9_bb_v: BB.v } }, function (j) {
          emit('attr', { value: v, ok: !!j });
          ensureAttr(1500);   // read it back once more
        });
      });
    }, delay);
  }
  if (Number(C.count) > 0 && C.attr !== BB.attr()) ensureAttr(400);
  // after an add: the slide cart's confirmed add (its own writes are done by then), the theme's cart event, a drawer add-on
  document.addEventListener('tk9:cart', function (e) { var d = e.detail || {}; if (d.event === 'tk9_cart_add_confirmed' || d.event === 'tk9_cart_offer_add') { attrTries = 0; ensureAttr(500); } });
  document.addEventListener('cart:update', function () { attrTries = 0; ensureAttr(1200); });

  /* ---------------- Waste Kit add-on (staged 2026-10-19 for the Waste Kit session; switch: bb_wastekit in the section)
     'off' = nothing; 'preview' = only a browser that opened a page with ?tk9_wk=1 (?tk9_wk=0 clears it); 'on' = everyone.
     Where: the 4MBH, lightweight and classic landers (pages and ?view= product pages), in "Build your kit", and the
     tactical leash product page above Add to cart. The kit is its own cart line in the harness or leash color (K9 Black
     for colors the kit does not come in), at its own live price; no savings line. Ticking it unticks the $34.99 pouch
     part (the kit has the pouch dispenser), and ticking the pouch unticks the kit. Slide cart on: the line goes in through
     window.TK9CartExtraItems right after the main item; slide cart off: it is added first, then the main add runs. */
  (function wasteKit() {
    var st = C.wk || 'off', forced = false;
    try { if (/[?&]tk9_wk=1/.test(location.search)) localStorage.setItem('tk9_wk', '1'); if (/[?&]tk9_wk=0/.test(location.search)) localStorage.removeItem('tk9_wk'); forced = localStorage.getItem('tk9_wk') === '1'; } catch (e) {}
    if (!(st === 'on' || (st === 'preview' && forced)) || C.cur !== 'USD') return;
    var HAR = { 'all-metal-tactical-harness': 1, 'lightweight-dog-harness': 1, 'metal-buckle-harness': 1 };
    var lroot = $('[data-tkd][data-tkd-product]');
    var handle = C.kind === 'lander' ? (lroot ? lroot.getAttribute('data-tkd-product') : '') : C.handle;
    var where = C.kind === 'lander' && HAR[handle] ? 'lander' : (C.kind === 'pdp' && handle === 'tactical-leash-sale' ? 'leash' : '');
    if (!where) return;
    var kit = null, on = false, preAdded = false, card = null;
    function drawerOn() { return !!(window.TK9Cart && typeof window.TK9Cart.active === 'function' && window.TK9Cart.active()); }
    function colorNow() {
      if (where === 'lander') { var c = $('[data-tkd] form [data-tkd-choice="0"][aria-pressed="true"]'); return c ? c.getAttribute('data-value') : ''; }
      var r = $$('product-form-component input[type="radio"]:checked, variant-picker input[type="radio"]:checked').filter(function (i) { return /colou?r/i.test(i.name || ''); })[0];
      return r ? r.value : '';
    }
    function kitVariant() {
      if (!kit) return null;
      var c = colorNow(), live = kit.variants.filter(function (v) { return v.available; });
      return live.filter(function (v) { return v.option1 === c; })[0] || live.filter(function (v) { return v.option1 === 'K9 Black'; })[0] || live[0] || null;
    }
    function props() { var o = { _tk9_wastekit: where }; if (where === 'lander' && lroot) o._tk9_lander = (lroot.getAttribute('data-tkd-key') || 'lander') + ':addon'; return o; }
    function paint() {
      if (!card) return;
      var v = kitVariant(), b = $('[data-tk9wk-toggle]', card);
      b.setAttribute('aria-pressed', String(on));
      setText($('[data-tk9wk-color]', card), v ? v.option1 : '');
      setText($('[data-tk9wk-price]', card), v ? '+' + money(v.price) : '');
      card.hidden = !v;
    }
    function pouchPressed() { var p = $('[data-tkd-part="pouch"]'); return p && p.getAttribute('aria-pressed') === 'true' ? p : null; }
    function mount() {
      if (card && document.body.contains(card)) return;
      card = document.createElement('div');
      card.className = 'tk9wk'; card.setAttribute('data-tk9wk', ''); card.setAttribute('data-watch-component', 'tk9.wastekit'); card.setAttribute('data-watch-kind', 'upsell');
      card.innerHTML = '<button type="button" class="tk9wk-opt" aria-pressed="false" data-tk9wk-toggle><span class="tk9wk-tick" aria-hidden="true"></span>' +
        '<span><b>' + (where === 'lander' ? 'Make it the Waste Kit' : 'Add the Waste Kit') + '</b><small>Pouch dispenser, MOLLE zip pouch for used bags and 10 rolls of bags <span class="tk9wk-sep">·</span> <span data-tk9wk-color></span></small></span>' +
        '<em data-tk9wk-price></em></button>';
      var spot = null;
      if (where === 'lander') { var bld = $('[data-tkd] form [data-tkd-builder]'); spot = bld || ($('[data-tkd] form [data-tkd-add]') || {}).parentElement; if (bld) bld.appendChild(card); else if (spot) spot.insertBefore(card, $('[data-tkd-add]', spot)); }
      else { var f = $('product-form-component form[action*="/cart/add"]'), sb = f && $('[type="submit"]', f); if (sb) { var blk = sb.closest('.product-form-buttons, .buy-buttons-block, .add-to-cart-button-block') || sb.parentElement; blk.parentElement.insertBefore(card, blk); } }
      if (!card.parentElement) { emit('error', { message: 'wastekit: no place to mount' }); card = null; return; }
      $('[data-tk9wk-toggle]', card).addEventListener('click', function () {
        on = !on; preAdded = false;
        var p = on && pouchPressed(); if (p) p.click();   // the kit has the pouch dispenser: no second pouch
        paint(); emit('wastekit', { on: on, where: where });
      });
      paint();
    }
    document.addEventListener('click', function (e) {
      var p = e.target.closest && e.target.closest('[data-tkd-part="pouch"]');
      if (p && on) setTimeout(function () { if (pouchPressed()) { on = false; paint(); } }, 0);
      if (e.target.closest && e.target.closest('[data-tkd-choice="0"], input[type="radio"], label')) setTimeout(paint, 60);
    }, true);
    var prevHook = window.TK9CartExtraItems;
    window.TK9CartExtraItems = function (f) {
      var out = []; try { out = prevHook ? (prevHook(f) || []) : []; } catch (e) { out = []; }
      var v = kitVariant();
      if (on && v && !preAdded && drawerOn()) out = out.concat([{ id: v.id, quantity: 1, properties: props() }]);
      return out;
    };
    // slide cart off: add the kit first, then the main add runs as usual
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest(where === 'lander' ? '[data-tkd] form [data-tkd-add]' : 'product-form-component [type="submit"]');
      if (!btn || !on || preAdded || drawerOn()) return;
      var v = kitVariant(); if (!v) return;
      e.preventDefault(); e.stopImmediatePropagation();
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props() }] }) })
        .then(function () {}).catch(function () {}).then(function () { preAdded = true; btn.click(); setTimeout(function () { preAdded = false; }, 30000); });
    }, true);
    document.addEventListener('tk9:cart', function (e) { var d = e.detail || {}; if (/add_confirmed/.test(d.event || '')) setTimeout(function () { preAdded = false; }, 1500); });
    fetch('/products/waste-kit.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (pk) {
      if (!pk || !pk.variants || !pk.variants.length) { emit('error', { message: 'wastekit: product not available' }); return; }
      kit = pk; mount();
      try { new MutationObserver(function () { if (!card || !document.body.contains(card)) mount(); }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
      emit('shown', { what: 'wastekit', where: where });
    }).catch(function () {});
    var css = document.createElement('style');
    css.textContent = '.tk9wk{margin:10px 0}.tk9wk-opt{display:flex;align-items:center;gap:10px;width:100%;padding:12px 14px;border:0;border-radius:14px;background:#fff;box-shadow:inset 0 0 0 1px #28345e33;text-align:left;font:inherit;color:inherit;cursor:pointer}' +
      '.tk9wk-opt[aria-pressed="true"]{box-shadow:inset 0 0 0 2px rgb(28,210,172);background:#f2fdf9}.tk9wk-opt b{display:block;font-size:14.5px}.tk9wk-opt small{display:block;font-size:12.5px;line-height:1.35;opacity:.75}' +
      '.tk9wk-opt em{margin-left:auto;font-style:normal;font-weight:700;white-space:nowrap}.tk9wk-tick{flex:none;width:20px;height:20px;border-radius:6px;box-shadow:inset 0 0 0 2px #28345e55}' +
      '.tk9wk-opt[aria-pressed="true"] .tk9wk-tick{background:rgb(28,210,172);box-shadow:none}';
    document.head.appendChild(css);
  })();

  if (!test) return;

  /* ---------------- Watch ---------------- */
  // The html attributes (set before paint) are what the recorder reads at start; this repeats it once Watch has loaded.
  // A lander keeps its own page version, so it is passed back as is.
  function watchExposed() {
    try {
      var rec = window.MerchantingWatch; if (!rec || typeof rec.track !== 'function') return;
      var root = C.kind === 'lander' ? $('[data-tkd][data-watch-page-version]') : null;
      var pv = C.kind === 'pdp' ? BB.exp + ':' + arm : (root ? root.getAttribute('data-watch-page-version') : '');
      rec.track('experiment_exposed', { experiment_id: BB.exp, variant_id: arm, page_version_id: pv });
    } catch (e) {}
  }
  [2500, 8000].forEach(function (t) { setTimeout(watchExposed, t); });
  emit('exposed', { kind: C.kind });

  if (arm !== 'B' || C.kind !== 'pdp') return;

  // The theme can redraw the product form on a variant change: everything is (re)mounted into the current form.
  function getForm() { return $('product-form-component form[action*="/cart/add"]'); }
  function getSticky() { return $('.sticky-add-to-cart__form'); }
  var form = getForm();
  if (!form) { emit('error', { message: 'no product form' }); return; }
  function formVariant() { var f = getForm(), i = f && f.querySelector('[name="id"]'); return i ? String(i.value) : ''; }
  function mountInto(el) {
    var f = getForm(); if (!f) return null;
    if (el.parentNode !== f) { var b = $('.product-form-buttons', f); if (b) f.insertBefore(el, b); else f.insertBefore(el, f.firstChild); }
    return f;
  }
  var remounts = [];
  function remountAll() { remounts.forEach(function (fn) { try { fn(); } catch (e) {} }); }
  var mo = null, moTimer = null, host = form.closest('.product-details, product-form-component') || document.body;
  try { mo = new MutationObserver(function () { clearTimeout(moTimer); moTimer = setTimeout(remountAll, 80); }); mo.observe(host, { childList: true, subtree: true }); } catch (e) {}
  document.addEventListener('variant:update', function () { setTimeout(remountAll, 60); setTimeout(remountAll, 600); });
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-swatch-king, variant-picker')) { setTimeout(remountAll, 60); setTimeout(remountAll, 600); } });

  var css = document.createElement('style');
  css.textContent =
    '.tk9bb-box{margin:0 0 14px;padding:0;border:0;min-width:0}' +
    '.tk9bb-box>legend,.tk9bb-h{display:block;width:100%;margin:0 0 10px;font-weight:700;font-size:15px;line-height:1.3;text-align:center}' +
    '.tk9bb-row{display:grid;grid-template-columns:1fr 1fr;gap:8px}' +
    '.tk9bb-opt{position:relative;display:grid;gap:2px;justify-items:start;margin:0;padding:11px 12px;border:0;border-radius:10px;background:#fff;color:inherit;' +
      'font:inherit;text-align:left;box-shadow:inset 0 0 0 1px rgba(0,0,0,.22);cursor:pointer;-webkit-appearance:none;appearance:none;min-height:48px}' +
    '.tk9bb-opt[aria-pressed="true"]{box-shadow:inset 0 0 0 2px rgb(28,210,172);background:#fff}' +
    '.tk9bb-opt b{font-size:15px;line-height:1.25}' +
    '.tk9bb-opt small{font-size:13.5px;line-height:1.3;opacity:.85}' +
    '.tk9bb-opt i{font-style:normal;font-size:13px;font-weight:700;color:#0f7b3f;line-height:1.3}' +
    '.tk9bb-kit .tk9bb-opt{grid-template-columns:22px 1fr auto;align-items:start;column-gap:10px;width:100%}' +
    '.tk9bb-kit .tk9bb-opt>em{font-style:normal;font-weight:700;font-size:15px;line-height:1.25;white-space:nowrap}' +
    '.tk9bb-tick{width:20px;height:20px;margin-top:1px;border-radius:5px;box-shadow:inset 0 0 0 2px currentColor;display:grid;place-items:center}' +
    '.tk9bb-opt[aria-pressed="true"] .tk9bb-tick{box-shadow:none;background:rgb(28,210,172)}' +
    '.tk9bb-opt[aria-pressed="true"] .tk9bb-tick::after{content:"";width:6px;height:11px;margin-top:-2px;border:solid #fff;border-width:0 2.5px 2.5px 0;transform:rotate(45deg)}' +
    '.tk9bb-fields{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:8px}' +
    '.tk9bb-fields[hidden]{display:none}' +
    '.tk9bb-fields label{display:grid;gap:4px;font-size:13px;font-weight:600}' +
    '.tk9bb-fields input{width:100%;min-height:44px;padding:8px 10px;border:1px solid rgba(0,0,0,.3);border-radius:8px;font:inherit;font-size:16px;text-transform:uppercase;background:#fff;color:inherit}' +
    '.tk9bb-err{grid-column:1/-1;margin:0;color:#b42318;font-size:13.5px;font-weight:600}' +
    '.tk9bb-err[hidden]{display:none}' +
    '.tk9bb-kit.is-missing input[data-bb-name]{border-color:#b42318;box-shadow:0 0 0 1px #b42318}' +
    'html.tk9bb-4mbh-B [id*="candy_rack_product_placement_checkbox"]{display:none!important}';
  document.head.appendChild(css);

  /* ---------------- doggles: 2 pairs chosen ---------------- */
  if (test === 'doggles') {
    var qtyIn = document.createElement('input'); qtyIn.type = 'hidden'; qtyIn.name = 'quantity'; qtyIn.setAttribute('data-bb-qty', '');
    var box = document.createElement('fieldset');
    box.className = 'tk9bb-box tk9bb-qty';
    box.setAttribute('data-watch-component', 'tk9.bb.doggles.qty'); box.setAttribute('data-watch-kind', 'variant');
    box.innerHTML = '<legend>How many pairs</legend><div class="tk9bb-row">' +
      '<button type="button" class="tk9bb-opt" data-bb-q="1" aria-pressed="false" data-watch-component="tk9.bb.doggles.qty-1" data-watch-kind="variant"><b>1 pair</b><small data-bb-p1></small></button>' +
      '<button type="button" class="tk9bb-opt" data-bb-q="2" aria-pressed="true" data-watch-component="tk9.bb.doggles.qty-2" data-watch-kind="variant"><b>2 pairs</b><small data-bb-p2></small><i data-bb-save></i></button></div>';
    var q = 2;
    function paintQty() {
      var f = mountInto(box); if (!f) return;
      // one quantity field in the form: ours (a theme quantity field, if one ever appears, is left to the theme)
      var own = f.querySelector('input[name="quantity"]');
      if (!own) { f.appendChild(qtyIn); own = qtyIn; }
      var price = C.prices && C.prices[formVariant()];
      var ok = price && price * 2 > C.deal;   // the deal only reads right where 2 pairs cost more than $99
      if (box.hidden !== !ok) box.hidden = !ok;
      var n = ok ? q : 1;
      own.value = String(n);
      var st = getSticky(), sq = st && st.querySelector('input[name="quantity"]'); if (sq) sq.value = String(n);
      if (!ok) return;
      setText($('[data-bb-p1]', box), money(price));
      setText($('[data-bb-p2]', box), money(C.deal) + ' for both');
      setText($('[data-bb-save]', box), 'Save ' + money(price * 2 - C.deal));
      $$('[data-bb-q]', box).forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-bb-q')) === q)); });
    }
    $$('[data-bb-q]', box).forEach(function (b) {
      b.addEventListener('click', function () { q = Number(b.getAttribute('data-bb-q')); paintQty(); emit('qty', { qty: q }); });
    });
    paintQty();
    remounts.push(paintQty);   // a size change can redraw the form: keep the choice and the quantity in step
    emit('shown', { what: 'qty', qty: q });
  }

  /* ---------------- couch: Kaching's Buy 2 chosen once ---------------- */
  if (test === 'couch') {
    var touched = false, tries = 0;
    document.addEventListener('pointerdown', function (e) { if (e.target && e.target.closest && e.target.closest('kaching-bundles-block')) touched = true; }, true);
    (function pick() {
      var blk = $('kaching-bundles-block'), r = blk ? $$('input[type="radio"]', blk) : [];
      if (r.length >= 2) {
        if (!touched && r[0].checked && !r[1].checked) { r[1].click(); emit('shown', { what: 'kaching_buy2', ok: !!r[1].checked }); }
        return;
      }
      if (++tries < 40) setTimeout(pick, 250); else emit('error', { message: 'kaching bars not found' });
    })();
  }

  /* ---------------- classic: the 4 metal buckle model chosen once (owner, 2026-10-19) ----------------
     The classic page's own picker (assets/tk9-harness-version-upgrade.js) does the rest: the 4MBH variant in the same
     color, size and kit, with _tk9_selected_from and _tk9_harness_version. One tap on the 2-buckle card = classic. */
  if (test === 'classic') {
    var ctouched = false, ctries = 0;
    document.addEventListener('pointerdown', function (e) { if (e.target && e.target.closest && e.target.closest('[data-tk9-harness-version]')) ctouched = true; }, true);
    (function pickUpgrade() {
      var card = $('[data-tk9-version-card="upgrade"]'), inp = card && card.querySelector('input[name="tk9_harness_version"]');
      if (card && inp) {
        if (!ctouched && !inp.checked && !inp.disabled && !card.classList.contains('is-disabled')) { card.click(); emit('shown', { what: 'classic_4mbh', ok: !!inp.checked }); }
        return;
      }
      if (++ctries < 60) setTimeout(pickUpgrade, 250); else emit('error', { message: 'version picker not found' });
    })();
  }

  /* ---------------- 4mbh: "Harness + custom name patch" kit option ---------------- */
  // 2026-10-20: the shared patch module (assets/tk9-pp-patch.js, kit mode) renders this option when it runs on the page
  if (test === '4mbh' && C.patch && C.patch.medium && C.patch.large && !(window.TK9PP && window.TK9PP.mode === 'kit' && window.TK9PP.arm === 'B')) {
    var NAME = 'Which text or name you want printed', PHONE = 'Which phone number you want printed (optional)';
    var kit = document.createElement('div');
    kit.className = 'tk9bb-box tk9bb-kit';
    kit.setAttribute('data-watch-component', 'tk9.bb.4mbh.kit'); kit.setAttribute('data-watch-kind', 'upsell');
    kit.innerHTML = '<p class="tk9bb-h">Kit option</p>' +
      '<button type="button" class="tk9bb-opt" aria-pressed="false" data-bb-kit data-watch-component="tk9.bb.4mbh.kit.patch" data-watch-kind="upsell"><span class="tk9bb-tick" aria-hidden="true"></span>' +
      '<span><b data-bb-kit-label>Harness + custom name patch</b><br><small>Their name and your number, printed on a pair</small></span><em>+' + money(C.patch.price) + '</em></button>' +
      '<div class="tk9bb-fields" data-bb-fields hidden>' +
      '<label>Name to print<input type="text" maxlength="15" autocomplete="off" autocapitalize="characters" enterkeyhint="done" data-bb-name></label>' +
      '<label>Phone (optional)<input type="text" maxlength="15" autocomplete="off" inputmode="tel" enterkeyhint="done" data-bb-phone></label>' +
      '<p class="tk9bb-err" data-bb-err hidden>Type the name to print, or untick the patch.</p></div>';
    var on = false, btn = $('[data-bb-kit]', kit), fields = $('[data-bb-fields]', kit), nameIn = $('[data-bb-name]', kit), phoneIn = $('[data-bb-phone]', kit), err = $('[data-bb-err]', kit);
    function checked(prefix) { var x = $$('input[type="radio"]').filter(function (i) { return i.checked && i.name.indexOf(prefix) === 0; })[0]; return x ? x.value : ''; }
    function kitLabel() { var k = checked('Choose a Kit') || 'Harness'; setText($('[data-bb-kit-label]', kit), k + ' + custom name patch'); }
    function patchVariant() { var s = checked('Choose a Size'); return /^(Extra-Small|Small)/i.test(s) ? C.patch.medium : C.patch.large; }
    // Without the slide cart, Candy Rack's popup takes the Add click before any submit. With the option ticked, its own
    // opt-out class on the add buttons lets our submit add the harness and the patch together; unticked = today's flow.
    function drawerOn() { return !!(window.TK9Cart && typeof window.TK9Cart.active === 'function' && window.TK9Cart.active()); }
    function crIgnore() {
      var want = on && !drawerOn();
      [getForm(), getSticky()].forEach(function (f) { if (!f) return; $$('[type="submit"]', f).forEach(function (b) { if (want) { b.classList.add('cr-ignore'); b.setAttribute('data-bb-cr', ''); } else if (b.hasAttribute('data-bb-cr')) { b.classList.remove('cr-ignore'); b.removeAttribute('data-bb-cr'); } }); });
    }
    function setOn(v) {
      on = v; btn.setAttribute('aria-pressed', String(on)); fields.hidden = !on; err.hidden = true; kit.classList.remove('is-missing'); crIgnore();
      if (on) setTimeout(function () { try { nameIn.focus({ preventScroll: true }); } catch (e) {} }, 30);
      emit('kit', { on: on });
    }
    btn.addEventListener('click', function () { setOn(!on); });
    nameIn.addEventListener('input', function () { if (nameIn.value.trim()) { err.hidden = true; kit.classList.remove('is-missing'); } });
    mountInto(kit);
    kitLabel();
    remounts.push(function () { mountInto(kit); kitLabel(); crIgnore(); });
    function patchProps() {
      var n = nameIn.value.trim(), p = phoneIn.value.trim(), o = {};
      o[NAME] = n; if (p) o[PHONE] = p;
      // the fields the /cart and slide cart patch rows write, so the mockup, production and reporting read it the same
      o._tk9_patch_mockup_format = 'svg_v4_pair_cart_single_preview';
      o._tk9_patch_mockup_line_1 = n; o._tk9_patch_mockup_line_2 = p;
      o._tk9_custom_patch_source = 'product_page'; o._tk9_custom_patch_label = 'Product page';
      o._tk9_custom_patch_surface = 'tk9_bb_kit'; o._tk9_custom_patch_source_label = 'Product page'; o._tk9_custom_patch_source_surface = 'tk9_bb_kit';
      o._tk9_upsell = 'bb:patch:kit';
      return o;
    }
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && (j.description || j.message) || 'cart error'); return j; }); });
    }
    // With the slide cart: its hook (live 2026-10-18 19:55 UTC) asks for extra lines at the Add press and posts them
    // right after the harness, before the drawer opens, so it shows both. Nothing extra unless the option is ticked.
    window.TK9CartExtraItems = function () {
      // only when the slide cart is the one adding (without it, our own submit adds both lines and goes to /cart)
      if (!on || !nameIn.value.trim() || !drawerOn()) return [];
      emit('kit_add', { via: 'drawer' });
      return [{ id: patchVariant(), quantity: 1, properties: patchProps() }];
    };
    // Before any add from this page (main form or the sticky bar): a ticked patch needs its name. Window capture runs
    // before the slide cart's document listener and the theme's form handler.
    window.addEventListener('submit', function (e) {
      var f = e.target; if (!on || !f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
      var main = getForm(), st = getSticky();
      if (f !== main && f !== st) return;
      if (!nameIn.value.trim()) {
        e.preventDefault(); e.stopImmediatePropagation();
        err.hidden = false; kit.classList.add('is-missing');
        try { kit.scrollIntoView({ block: 'center', behavior: 'smooth' }); nameIn.focus({ preventScroll: true }); } catch (x) {}
        emit('kit_need_name', {});
        return;
      }
      var drawer = drawerOn();
      if (drawer && f === st && main) {
        // the slide cart takes adds from the product form: the sticky bar's add goes through it, same variant
        e.preventDefault(); e.stopImmediatePropagation();
        var mb = main.querySelector('[type="submit"]');
        try { if (main.requestSubmit) main.requestSubmit(mb || undefined); else if (mb) mb.click(); } catch (x) { if (mb) mb.click(); }
        return;
      }
      if (!drawer) {
        // no slide cart in this browser: add the harness and the patch together, then /cart (today's cart page)
        e.preventDefault(); e.stopImmediatePropagation();
        var fd = new FormData(f), item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1), properties: {} };
        fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m) item.properties[m[1]] = v; });
        post('/cart/add.js', { items: [item, { id: patchVariant(), quantity: 1, properties: patchProps() }] })
          .then(function () { emit('kit_added', { via: 'cart_page' }); ensureAttr(0); setTimeout(function () { location.href = '/cart'; }, 150); })
          .catch(function () { f.submit(); });
      }
    }, true);
    emit('shown', { what: 'kit' });
  }
})();
